module.exports = __webpack_public_path__ + "img/UI_common_framelabelPX_02_93fce41bb.png";